import React, { useId, useState } from "react";

import clsx from "clsx";

import { Label, IconCaret, Collapse, UnstyledButton } from "@busbud/horizon";

export type FilterCollapseProps = React.PropsWithChildren<{
  className?: string;
  title: string;
}>;

export const FilterCollapse = ({
  title,
  children,
  className
}: FilterCollapseProps) => {
  const [collapse, setCollapse] = useState(true);
  const id = useId();

  const iconClasses =
    "text-color-primary rounded-sm  group-hover:bg-color-film-secondary";
  const IconCaretRender = () =>
    collapse ? (
      <IconCaret size="sm" variant="up" className={iconClasses} />
    ) : (
      <IconCaret variant="down" size="sm" className={iconClasses} />
    );

  return (
    <fieldset className={clsx("group py-200 first:pt-150", className)}>
      <h3 className="flex">
        <UnstyledButton
          ariaControls={id}
          ariaExpanded={collapse}
          onClick={() => setCollapse(!collapse)}
          aria-expanded={collapse}
        >
          <Label fontWeight="bold" iconStart={<IconCaretRender />} as="div">
            {title}
          </Label>
        </UnstyledButton>
      </h3>
      <Collapse
        withTransition={true}
        id={id}
        aria-hidden={!collapse}
        isExpanded={collapse}
      >
        {children}
      </Collapse>
    </fieldset>
  );
};
